import Data from '../data/contact.json';
import { langData } from "../libs/Utils";
import React, { useEffect, useState } from 'react';

export const Contact = (props) => {
    const { lang, ua } = props;
    const nowData = langData(lang, Data);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        setLoaded(true);
    }, [])

    const contentClass = (ua === "pc" ? "contact-content content-offset" : "contact-content");

    return (
        <div id="contact" className={"page-wrapper " + (loaded ? "opacity-one" : "opacity-zero")}>
            <div className="title">CONTACT</div>
            <div className={contentClass}>
                {nowData.contact.map((d, i) => {
                    return (
                        <div key={"c_" + i} className="contact-list">
                            <p className="contact-list-index">{d.index + ":"}</p>
                            <p>{d.content}</p>
                        </div>);
                })}

            </div>
            <div className="title">COLLABORATION</div>
            <div className={contentClass}>
                {nowData.collaboration.map((d, i) => {
                    return (
                        <div key={"cl_" + i} className="collaboration">
                            {d}
                        </div>);
                })}
            </div>
        </div>
    );
}